<template>
  <div class="page-container" v-if="currentNews">
    <h1 class="page-title">{{ currentNews.title }}</h1>
    <p style="text-align: right;">2018-08-16</p>
    <div class="content">
      <!-- 第一段内容：会议概述 -->
      <div class="content-section">
        <div class="text-block">
          <p v-html="currentNews.content?.split('---')[0] || ''"></p>
        </div>
      </div>

      <!-- 会议图片1 -->
      <div class="content-section image-section">
        <div class="image-container">
          <img :src="currentNews.other?.picture1?.url" :alt="currentNews.other?.picture1?.caption">
          <p class="image-caption">{{ currentNews.other?.picture1?.caption }}</p>
        </div>
      </div>

      <!-- 第二段内容：专家致辞 -->
      <div class="content-section">
        <div class="text-block">
          <p v-html="currentNews.content?.split('---')[1] || ''"></p>
        </div>
      </div>

      <!-- 会议图片2 -->
      <div class="content-section image-section">
        <div class="image-container">
          <img :src="currentNews.other?.picture2?.url" :alt="currentNews.other?.picture2?.caption">
        </div>
      </div>
<div class="content-section image-section">
        <div class="image-container">
          <img :src="currentNews.other?.picture3?.url" :alt="currentNews.other?.picture3?.caption">
   
        </div>
      </div>
      <div class="content-section image-section">
        <div class="image-container">
          <img :src="currentNews.other?.picture4?.url" :alt="currentNews.other?.picture4?.caption">

        </div>
      </div>
      <!-- 第三段内容：行业突破 -->
      <div class="content-section">
        <div class="text-block">
          <p v-html="currentNews.content?.split('---')[2] || ''"></p>
        </div>
      </div>

      <!-- 第四段内容：上海超导进展和展望 -->
      <div class="content-section">
        <div class="text-block">
          <p v-html="currentNews.content?.split('---')[3] || ''"></p>
        </div>
      </div>
    </div>
  </div>
  <div v-else class="page-container">
    <p>新闻内容未找到</p>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { useLangStore } from '../../../pinia/stores/lang';
import zhData from '../../../i18n/zh';
import enData from '../../../i18n/en';

const langStore = useLangStore();

// 获取新闻数据的方法
const currentNews = computed(() => {
  const translationData = langStore.currentLang.startsWith('zh') ? zhData : enData;
  const newsList = translationData.pages.news.company.news.list;
  // 通过ID查找新闻
  const newsItem = newsList.find((news: any) => news.id === 'shanghaichaodaohuiyi');
  return newsItem || {};
});

</script>

<style scoped lang="scss">
.page-container {
  overflow: auto;
}

.content-section {
  margin-bottom: 20px;
}

.text-block p {
  text-indent: 2em; /* First line indent */
  line-height: 1.8; /* Line height */
  margin-bottom: 1em; /* Paragraph spacing */
}

.image-section {
  text-align: center;
}

.image-container {
  display: inline-block;
  margin: 10px 0;
}

.image-container img {
  max-width: 80%; /* Adjust width as needed */
  height: auto; /* Maintain aspect ratio */
  border-radius: 4px;
}

.image-caption {
  margin-top: 8px;
  font-size: 14px;
  color: #666;
}

// Highlight style
:deep(.highlight) {
  color: #e58a00; /* Example highlight color */
  font-weight: bold;
}
</style> 